var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 7.33333C6.66667 8.06971 6.06971 8.66667 5.33333 8.66667C4.59695 8.66667 4 8.06971 4 7.33333C4 6.59695 4.59695 6 5.33333 6C6.06971 6 6.66667 6.59695 6.66667 7.33333ZM8.66663 6.33337C8.11434 6.33337 7.66663 6.78109 7.66663 7.33337C7.66663 7.88566 8.11434 8.33337 8.66663 8.33337H18.6666C19.2189 8.33337 19.6666 7.88566 19.6666 7.33337C19.6666 6.78109 19.2189 6.33337 18.6666 6.33337H8.66663ZM7.66663 12C7.66663 11.4477 8.11434 11 8.66663 11H18.6666C19.2189 11 19.6666 11.4477 19.6666 12C19.6666 12.5523 19.2189 13 18.6666 13H8.66663C8.11434 13 7.66663 12.5523 7.66663 12ZM6.66667 12C6.66667 12.7363 6.06971 13.3333 5.33333 13.3333C4.59695 13.3333 4 12.7363 4 12C4 11.2636 4.59695 10.6666 5.33333 10.6666C6.06971 10.6666 6.66667 11.2636 6.66667 12ZM7.66663 16.6666C7.66663 16.1143 8.11434 15.6666 8.66663 15.6666H18.6666C19.2189 15.6666 19.6666 16.1143 19.6666 16.6666C19.6666 17.2189 19.2189 17.6666 18.6666 17.6666H8.66663C8.11434 17.6666 7.66663 17.2189 7.66663 16.6666ZM6.66667 16.6667C6.66667 17.4031 6.06971 18 5.33333 18C4.59695 18 4 17.4031 4 16.6667C4 15.9303 4.59695 15.3334 5.33333 15.3334C6.06971 15.3334 6.66667 15.9303 6.66667 16.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineList);
export default __webpack_public_path__ + "static/media/line-list.1c42361edec76caf97ac9644586793b1.svg";
export { ForwardRef as ReactComponent };